import { render, staticRenderFns } from "./PoFilters.vue?vue&type=template&id=852d2b50"
import script from "./PoFilters.vue?vue&type=script&lang=js"
export * from "./PoFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports